import i18next from 'i18next';
import { action, computed, observable } from 'mobx';
import { AGENT_DEFAULT_ORG } from '@link/share/constants';
import { Ota, OtaOrg } from '@link/share/services/types';

export class BaseAgent {
  @observable accessor allOtas: Ota[] = [];
  @observable accessor targetOtaOrgs: OtaOrg[] = [];
  @observable accessor allOtasLoaded = false;
  @observable accessor targetOtaOrgsLoaded = false;

  @action
  setAllOtas(otas: Ota[]) {
    this.allOtas = otas;
  }

  @action
  setAllOtasLoaded(loaded: boolean) {
    this.allOtasLoaded = loaded;
  }

  @action
  setOtaOrgs(otas: OtaOrg[]) {
    this.targetOtaOrgs = otas;
  }

  @action
  setTargetOtaOrgsLoaded(loaded: boolean) {
    this.targetOtaOrgsLoaded = loaded;
  }

  @computed
  get targetOtaId() {
    return this.targetOtaOrgs[0]?.otaId || '';
  }

  @computed
  get otaOpts() {
    return this.allOtas.map(ota => ({
      label: i18next.t('share.common.formTitle', {
        title: ota.originalName,
        id: ota.otaCustomId
      }),
      value: ota.otaId || ''
    }));
  }

  @computed
  get otaOrgOpts() {
    return this.targetOtaOrgs.map(org => ({
      label: org.otaOrgName || '',
      value: org.otaOrgId || '',
      parentOtaOrgId: org.parentOtaOrgId || ''
    }));
  }

  @computed
  get defaultParentOrgId() {
    const match = this.targetOtaOrgs.find(
      org => String(org.parentOtaOrgId ?? '') === AGENT_DEFAULT_ORG
    );
    return match?.otaOrgId || '';
  }
}
